/**
 * Tier 1 compiled MCP policy — read-only mirror of engine-mcp/src/policy.ts.
 * Update both when safety rules change; redeploy engine-mcp for hosted connector.
 */
export const MCP_TIER1_POLICY = {
  version_note: 'Version and deploy time come from engine-mcp deploy (engine_get_build_info).',
  mode: 'read + crm-write + draft-write + tasks + thoughts',
  auth: 'github-oauth',
  memory_layers: [
    'Tier 1 — compiled at deploy (this panel + policy.ts)',
    'Tier 2 — agent_directives table (preferences)',
    'Tier 3 — agent_context_briefs table (curated snippets)',
    'Tier 4 — agent_workflows table (tool-chain playbooks)',
  ],
  allowed: [
    'Daily docket and plan status (tasks + sends)',
    'List/create/update tasks (not delete)',
    'Create/update/delete content ideas (thoughts) — delete requires confirm=true',
    'Search and read CRM connections and timelines',
    'Read newsletters, calendar, engagement, automations',
    'Semantic connection search',
    'Create/update Draft newsletters and append blocks',
    'Update subscriber CRM fields',
    'Session context + remember/list/revoke directives',
    'Manual action URLs for live or destructive ops',
  ],
  forbidden: [
    'Send email or trigger Postmark',
    'Materialize newsletter recipients',
    'Change newsletter status to scheduled / published via MCP',
    'Set scheduled_for on locked sends via MCP',
    'Delete subscribers, newsletters, or tasks',
    'Cancel or force-send scheduled emails via MCP',
  ],
  locked_send_rule:
    'When status is scheduled (or ready_to_publish / published) and scheduled_for is set, treat as locked — read only.',
  repo: 'Low-Code-CTO/mcp (engine-mcp/)',
  hosted_url: 'https://mcp.stephansmith.me/mcp',
};
